<template>
  <div class="import-transferencias-participantes">
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Transferencias">
          <b-table hover
              responsive="sm" 
              class="registro transferencias"
              :busy="tableBusy"
              :items="transferencias" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaTransferencia)="data">
              {{ data.item.fechaTransferencia | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(importeTransferido)="data">
              {{ data.item.importeTransferido | moneda }}
            </template>

            <template v-slot:cell(detailShowing)="row">
              <b-btn class="detailShowing" 
                  size="sm" 
                  @click.stop="row.toggleDetails">
                {{ ( row.detailShowing) ? '-' : '+' }}
              </b-btn>            
            </template>

            <template slot="row-details" slot-scope="row"> 
              <b-row  v-if="row.item.error">
                <b-col xl="12">
                  <p class="descripcion"> {{ row.item.mensajeError }} </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col xl="12">
                  <b-table 
                      class="registro participantes" 
                      responsive="sm" 
                      :items="row.item.transferenciasParticipantes" 
                      :fields="participantesFields">
                    <template v-slot:cell(importe)="data">
                      {{ data.item.importe | moneda }}
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </template>
          </b-table>
          <!-- <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav> -->
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Importar</b-button>
            <b-button size="sm" variant="primary" class="footer-button" 
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'importTransferencias/getField',
  mutationType: 'importTransferencias/updateField',
});

export default {
  name: 'ImportTransferenciasParticipantes',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        { 
          key: 'titularCuenta',
        },
        { 
          key: 'banco',
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'fechaTransferencia',
        },
        { 
          key: 'importeTransferido',
          class: 'text-right'
        },
        { 
          key: 'motivoRechazo',
        },
      ],

      participantesFields: [
        { 
          key: 'participante' 
        },
        {
          key: 'importe',
          class: 'text-right' 
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'transferencias',
    ]),
  },
  methods: {
    save() {
      this.showSpinner();
      this.$store.dispatch('importTransferencias/save')
        .then(()  => this.showModalMsj('Las transferencias se registraron con éxito.', this.goBack, this.goBack, 'light'))
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    goBack() {
      this.$router.push({ name: 'ImportTransferenciasFile' });
    },
  },
  watch: {
  }    
}
</script>

<style>
  .import-transferencias table th {
    border-top: none;
  }
  .import-transferencias table td {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .import-transferencias .registro.transferencias table td[aria-colindex="1"] {
    width: 30px;
  }
  .import-transferencias .registro.transferencias table td[aria-colindex="2"] {
    width: calc(15% - 15px);
  }
  .import-transferencias .registro.transferencias table td[aria-colindex="3"] {
    width: 25%;
  }
  .import-transferencias .registro.transferencias table td[aria-colindex="4"],
  .import-transferencias .registro.transferencias table td[aria-colindex="5"],
  .import-transferencias .registro.transferencias table td[aria-colindex="6"] {
    width: 10%;
  }
  .import-transferencias .registro.transferencias table td[aria-colindex="7"] {
    width: calc(30% - 15px);
  }

  .import-transferencias .registro.transferencias table p.descripcion {
    margin-bottom: 5px;
    padding-left: 40px;
    width: calc(90% - 40px);
    white-space: pre-wrap;
  }

  .import-transferencias .registro.participantes table td[aria-colindex="1"] {
    width: 80%;
  }
  .import-transferencias .registro.participantes table td[aria-colindex="2"] {
    width: 20%;
  }
</style>
